import { useConfig } from 'context/app-config';
import { toFixed as toFixedNumber } from 'utils/helpers';

export function useFormattedDecimal() {
  const config = useConfig();

  const toFixed = (value: number, decimals: number) => (config?.twoDecimalPricingValues ? toFixedNumber(value, decimals) : value);

  return {
    toFixed,
  };
}
